<template>
    <div>
        <el-dialog
            title="开屏广告站点"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <div class="formContent">
                <el-table :data="changeTableData">
                    <el-table-column label="站点ID">
                        <template slot-scope="{ row }">
                            <span>{{ row.stationId || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="站点名称">
                        <template slot-scope="{ row }">
                            <span>{{ row.stationName || '-' }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <el-button type="primary"  @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                stationList: []
            };
        },
        methods:{
            submit () {
                
                
            },
        }
    }
</script>

<style scoped lang='scss'>
/deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
</style>